import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CustomClientError from '../../../../../errorhandling/CustomClientError';
import { formatDoctorName } from '../../../../../utils/common';
import AffiliatedDoctorsSkeleton from '../../skeleton/AffiliatedDoctorsSkeleton';

const AffiliatedDoctors = ({
  affiliatedDoctorsList,
  serverError,
  skeletonLoader,
}) => {
  return (
    <>
      {serverError && (
        <CustomClientError
          ErrorHeading="Something went wrong with the request!"
          ErrorMessage="Please try again."
        />
      )}
      {!serverError &&
        (skeletonLoader ? (
          <AffiliatedDoctorsSkeleton />
        ) : (
          <Row className="m-0">
            {affiliatedDoctorsList.FacilityAffiliatedDoctors?.length > 0 &&
              affiliatedDoctorsList.FacilityAffiliatedDoctors.map(
                (item, index) => (
                  <Col sm={12} className="each-doctor" key={index}>
                    {item?.FirstName ? (
                      <p className="provider-details-heading">
                        {formatDoctorName(
                          item?.DoctorTitle,
                          item?.LastName,
                          item?.FirstName,
                          item?.MiddleName,
                          item?.Suffix,
                        )}
                      </p>
                    ) : (
                      'No Details found'
                    )}
                    <p className="provider-details-data ml-0">
                      {item.Specialities.join(', ')}
                    </p>
                    <p className="provider-details-data ml-0">{`${
                      item.Phone != null ? 'Phone: ' + item.Phone : ''
                    }`}</p>
                  </Col>
                ),
              )}
          </Row>
        ))}
    </>
  );
};
export default AffiliatedDoctors;
